import { getTenantConfig } from './tenant-context';
import type { TenantLetterAssets } from './tenant-registry';

function cloneDefinition<T>(value: T): T {
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(value);
    } catch {
      // pdfmake definitions may contain callback functions (e.g. footer/header),
      // which cannot be cloned via structuredClone.
    }
  }
  return deepClone(value);
}

function deepClone<T>(value: T): T {
  if (value === null || value === undefined) return value;
  if (typeof value === 'function') return value;
  if (typeof value !== 'object') return value;
  if (value instanceof Date) return new Date(value.getTime()) as unknown as T;
  if (Array.isArray(value)) return value.map(item => deepClone(item)) as unknown as T;

  const cloned: Record<string, unknown> = {};
  for (const [key, item] of Object.entries(value as Record<string, unknown>)) {
    cloned[key] = deepClone(item);
  }
  return cloned as T;
}

export function getTenantLetterAssets(): TenantLetterAssets {
  const resolved = getTenantConfig().letterAssets;
  return {
    a4Letter: cloneDefinition(resolved.a4Letter),
    a4Letter2nd: cloneDefinition(resolved.a4Letter2nd),
    jobLabel: cloneDefinition(resolved.jobLabel),
  };
}
